/**
 * Simple compile-time feature flags. The frontend has no runtime config/flag
 * system, so a plain constant is the most reversible switch: flip a value here
 * to enable/disable a feature across the app.
 */

/**
 * Controls visibility of the courier equipment store (portal card, the
 * training completion CTA, and the /portal/store page). Kept off until the
 * store is ready to be shown to couriers. Flip to `true` to reveal it.
 */
export const EQUIPMENT_STORE_ENABLED = false;
